import backendUrls from './backendUrls.js';

const socketConfig = {
  SOCKET_URL: backendUrls.SOCKET_URL
};

export default socketConfig;